<template>
  <div
    :class="{ 'brightness-95': this.$store.state.displayEditWebhook }"
    class="box shadow-none col-span-6"
  >
    <div
      class="text-left lg:text-left p-5 border-t border-gray-200 dark:border-dark-5"
    >
      <div class="flex flex-col flex-nowrap">
        <div class="mb-3 flex">
          <label class="font-bold text-xl form-label mr-3 mb-0">Webhook:</label>
          <ToggleSlide
            class="w-min pointer-events-none"
            :key="webhookBool"
            :bool="webhookBool"
            :disabled="true"
          />
        </div>
        <div v-if="webhookBool">
          <Accordion
            :key="'webhook' + index"
            v-for="(item, index) in webhookJobs"
            class="mt-3 mb-2 border border-gray-300 p-1 box"
          >
            <template v-slot:title>
              <span class="font-semibold text-lg">{{ item.name }}</span>
            </template>
            <template v-slot:content>
              <div class="flex flex-col">
                <div class="flex flex-row">
                  <div class="w-1/2 mr-6">
                    <Field
                      title="Name:"
                      type="text"
                      :modelValue="item.name"
                      :disabled="true"
                    />
                  </div>
                  <div class="w-1/2">
                    <Field
                      title="URL:"
                      type="text"
                      :modelValue="item.url"
                      :disabled="true"
                      :copySuffix="true"
                      :isCopied="copiedField === 'url' + index"
                      @copy="copy(item.url, 'url' + index)"
                    />
                  </div>
                </div>
                <div class="flex flex-row">
                  <div class="w-1/2 mr-6">
                    <Field
                      title="API key:"
                      type="password"
                      :modelValue="item.headers?.apiKey"
                      :disabled="true"
                      :copySuffix="!!item.headers?.apiKey"
                      :isCopied="copiedField === 'apiKey' + index"
                      @copy="copy(item.headers?.apiKey, 'apiKey' + index)"
                    />
                  </div>
                  <div class="w-1/2 mb-3">
                    <p class="font-bold form-label">Event types:</p>
                    <DropdownSelectAll
                      :data="eventTypeOptions"
                      :selected="item.eventTypes"
                      :noSelectAll="true"
                      :disabled="true"
                    />
                  </div>
                </div>
                <div class="mb-3 flex">
                  <label class="font-bold form-label mr-3 mb-0"
                    >Base64 documents:</label
                  >
                  <ToggleSlide
                    class="w-min pointer-events-none"
                    :key="item.pdfFormat"
                    :bool="item.pdfFormat === 'base64'"
                    :disabled="true"
                  />
                </div>
              </div>
            </template>
          </Accordion>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Accordion from "../Accordion.vue";
import ToggleSlide from "../ToggleSlide.vue";
import Field from "../Field.vue";
import DropdownSelectAll from "../DropdownSelectAll.vue";
import webhookEventTypes from "@/webhookEventTypes";

export default {
  name: "ViewWebhookChannel",
  components: {
    Accordion,
    ToggleSlide,
    Field,
    DropdownSelectAll,
  },
  data() {
    return {
      copiedField: "",
      eventTypeOptions: webhookEventTypes,
    };
  },
  computed: {
    webhookBool() {
      return !!this.$store.state.activeSG.channelsConfig.webhook;
    },
    webhookJobs() {
      return (
        this.$store.state.activeSG.channelsConfig.webhook?.webhookJobs ?? []
      );
    },
  },
  methods: {
    copy(value, field) {
      navigator.clipboard.writeText(value);
      this.copiedField = field;
      setTimeout(() => {
        this.copiedField = "";
      }, 750);
    },
  },
};
</script>
